import { render } from "./ViewRouter.vue?vue&type=template&id=8d961422&scoped=true"
import script from "./ViewRouter.vue?vue&type=script&lang=js"
export * from "./ViewRouter.vue?vue&type=script&lang=js"

import "./ViewRouter.vue?vue&type=style&index=0&id=8d961422&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d961422"]])

export default __exports__